import {API_MODULES, API_ROUTES, API_SOLUTIONS} from "@api/ApiRoutes";
import {generateApiEndpoint} from "@api/ApiUtils";
import {getRequest, postRequest} from "@api/ApiService";
import {
    Event,
    EventFilters, Invoice, InvoicesResponse,
    SendEventRequest,
    SendEventResponse,
    VerifyFilesRequest,
    VerifyFilesResponse
} from "@lib/Event/EventModels";
import {toSearchParams} from "@commons/Utils";
import {PaginationParameters} from "@api/ApiModels";

const ROUTES = {
    GET_EVENT_LIST: {
        path: API_ROUTES.GET_EVENT_LIST,
        module: API_MODULES.FORMAT_EVENT,
        solution: API_SOLUTIONS.MZ
    },
    GET_EVENT_DETAILS: {
        path: API_ROUTES.GET_EVENT_DETAILS,
        module: API_MODULES.FORMAT_EVENT,
        solution: API_SOLUTIONS.MZ
    },
    VERIFY_FILES: {
        path: API_ROUTES.VERIFY_FILES,
        module: API_MODULES.EXT,
        solution: API_SOLUTIONS.MZ
    },
    SEND_EVENT: {
        path: API_ROUTES.SEND_EVENT,
        module: API_MODULES.FORMAT_EVENT,
        solution: API_SOLUTIONS.MZ
    },
    GET_INVOICES: {
        path: API_ROUTES.GET_INVOICES,
        module: API_MODULES.EXT,
        solution: API_SOLUTIONS.MZ
    },
    GET_INVOICE: {
        path: API_ROUTES.GET_INVOICE,
        module: API_MODULES.EXT,
        solution: API_SOLUTIONS.MZ
    },
}

class EventService {

    static getEventList = async (filters: Required<EventFilters>): Promise<Event[]> => {
        const url = generateApiEndpoint(ROUTES.GET_EVENT_LIST);

        const params = toSearchParams(filters);

        const qs = params.toString();

        return await getRequest<Event[]>(qs ? `${url}?${qs}` : url);
    }

    static getEventDetails = async (eventLogicId: string): Promise<Event> => {
        const url = generateApiEndpoint({
            ...ROUTES.GET_EVENT_DETAILS,
            params: {
                eventLogicId
            }
        });
        return await getRequest<Event>(url);
    }

    static getInvoices = async (filters: PaginationParameters): Promise<Invoice[]> => {
        const url = generateApiEndpoint(ROUTES.GET_INVOICES);

        const params = toSearchParams(filters);

        const qs = params.toString();

        const {results} = await getRequest<InvoicesResponse>(qs ? `${url}?${qs}` : url);

        return results;
    }

    static sendEvent = async (eventId: string, payload: SendEventRequest): Promise<SendEventResponse> => {

        const url = generateApiEndpoint({
            ...ROUTES.SEND_EVENT,
            params: {eventId}
        });

        return await postRequest<SendEventResponse, SendEventRequest>(url, payload);
    }

    static checkFiles = async (refs: string[]): Promise<boolean> => {

        const url = generateApiEndpoint(ROUTES.VERIFY_FILES);

        const payload: VerifyFilesRequest = {
            invoiceUrl: [...refs]
        };

        const {isInvoice} = await postRequest<VerifyFilesResponse, VerifyFilesRequest>(url, payload);

        return isInvoice;
    }

}

export default EventService;